export default () => {
  document
    .querySelectorAll(".js-hero-v2-video-banner")
    .forEach((heroV2VideoBanner) => {
      const backgroundVideoButton = heroV2VideoBanner.querySelector(
        ".js-hero-background-video-button",
      );

      const backgroundArrowButton = heroV2VideoBanner.querySelector(
        ".js-hero-background-arrow-button",
      );

      const playPauseVideo = (event) => {
        const containerEl =
          event.currentTarget !== undefined
            ? event.currentTarget.parentElement.parentElement
            : event;

        const videoEL = containerEl.querySelector(".js-background-video-el");
        if (!videoEL) {
          return;
        }
        videoEL.muted = true;

        setTimeout(() => {
          if (event.type === undefined) {
            videoEL?.play();
          }
        }, 100);

        if (videoEL.paused) {
          videoEL.play();
          containerEl.classList.add("is-playing");
        } else {
          videoEL.pause();
          containerEl.classList.remove("is-playing");
        }
      };

      function ScrollToArrow() {
        if (document.getElementById("scroll-arrow")) {
          //window.scrollTo(0, nextElement.getBoundingClientRect().top + window.pageYOffset);
          //nextElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
          document
            .getElementById("scroll-arrow")
            .scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }

      backgroundArrowButton?.addEventListener("click", ScrollToArrow);

      if (heroV2VideoBanner.length !== 0) {
        playPauseVideo(heroV2VideoBanner);
        backgroundVideoButton?.addEventListener("click", playPauseVideo);
      } else {
        console.info("No video element found in the hero slider.");
      }
    });
};
